module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lsmrq"))).then(() => parcelRequire('d0iPb'));